import { Box, Divider, Skeleton, Typography } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import { useAppSelector } from '../../hooks/useRedux';
import { Tabs } from '../../components';
import QuickGlance from './QuickGlance';
import Customer from './Customer';
import TeamList from './TeamList';
import img1 from '../../assets/images/car.png';
import Vehicle from './Vehicle';

const VehicleImage = styled('div')(`
  height: 210px;
  object-fit: cover;
  object-position: center;
  overflow: hidden;
  position: relative;
  img{
    min-height: 302px;
    width: 450px;
    object-fit: cover;
    object-position: top;
    position: absolute;
    left: 0;
    right: 0;
    margin: 15px auto 0 15px;
    top: 50%;
    transform: translateY(-50%);
  }
  @media(max-width: 1366px){
    height: 150px;
  }
`);

const tabItems = [
  {
    label: 'Quick Glance',
    content: <QuickGlance />,
  },
  {
    label: 'Vehicle',
    content: <Vehicle />,
  },
  {
    label: 'Customer',
    content: <Customer />,
  },
  // {
  //   label: 'Documents',
  //   content: (
  //     <Box alignItems="center" gap={1.75} display="flex" flexDirection="column" mt={3} mb={5} px={4}>
  //       <Box alignItems="center" gap={1.25} display="flex" flexDirection="column">
  //         <Typography fontSize={16} fontWeight={500} lineHeight="120%" color="black" textAlign="center">
  //           Currently, the documents are not available.
  //         </Typography>
  //         <Typography fontSize={14} fontWeight={500} lineHeight="130%" color="#A2A2A2" px={2} textAlign="center">
  //           The documents will appear here.
  //         </Typography>
  //       </Box>
  //     </Box>
  //   ),
  // },
];

const VehicleTabs = ({ loading }: { loading: boolean }) => {
  // use hooks
  const image = useRef<any>(null);

  // global states
  const img = useAppSelector((state) => {
    const formatUrl = state.vehicle.data?.configuration?.imageUrl;
    if (formatUrl) {
      const url = new URL(formatUrl);
      const { searchParams } = url;

      url.searchParams.set('width', '630');
      url.searchParams.set('height', '472.5');
      url.searchParams.set('format', 'png');
      // url.searchParams.set('camera', 'Angle_EXT_10_0010');
      url.searchParams.set('background_colour', '00000000');
      // url.searchParams.set('env', 'lucid_studio');

      // change the search property of the main url
      url.search = searchParams.toString();

      // the new url string
      const newUrl = url.toString();

      return newUrl;
    }
    return null;
  });

  // handling image src
  const handleImageSrc = () => {
    if (image?.current) image.current.src = img?.replace?.('prelive', 'live');
  };

  const handlingImage = () => {
    if (loading) {
      return <Skeleton variant="rectangular" width={390} height={200} />;
    }
    if (img && img !== '') {
      return (
        <VehicleImage>
          <img
            loading="lazy"
            ref={image}
            src={img}
            onError={handleImageSrc}
            alt="car"
            style={{ width: '100%', minHeight: 120 }}
          />
        </VehicleImage>
      );
    }
    return (
      <Box width={390} height={200} boxShadow={1}>
        <Typography
          variant="body2"
          fontWeight={500}
          paddingTop="22%"
          paddingLeft="13%"
          lineHeight={1.4}
          minWidth={150}
          fontSize={12}
          color="gray"
        >
          Vehicle image is not available to display
        </Typography>
      </Box>
    );
  };

  useEffect(() => {
    return () => {
      if (image?.current) image.current = null;
    };
  }, []);

  return (
    <Box sx={{ px: 2 }}>
      {handlingImage()}
      <Divider sx={{ mt: 2, borderColor: '#E9E9E9;' }} />
      <Tabs tabItems={tabItems} sx={{ fontSize: '14px' }} />
    </Box>
  );
};

export default VehicleTabs;
